var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditNegIcon = function SvgEditNegIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.65 20.33h4.675l9.35-9.638L12 5.872l-9.35 9.64zM12 5.8729999999999976l4.675 4.82M12 5.872l2.273-2.157a1.56 1.56 0 0 1 2.177.031l2.496 2.507c.61.612.605 1.603-.01 2.21l-2.261 2.228"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditNegIcon);
export { ForwardRef as Icon };
export default "customIcons/edit-neg-icon.85d743d.svg";